import { setAnalyticsConsent } from '../utils/analytics';
import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
const KEY = 'color-match-analytics-v1';
const ID = 'G-1Z37GFBBL0';
let lastView = '';
declare global { interface Window { gtag: (...args: unknown[]) => void; dataLayer: unknown[]; } }
function getChoice() { try { return localStorage.getItem(KEY); } catch { return null; } }
function disableAnalytics() {
  (window as unknown as Record<string, unknown>)['ga-disable-' + ID] = true;
  window.gtag?.('consent', 'update', { analytics_storage: 'denied' });
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (!/^_ga(?:_|$)/.test(name)) return;
    for (const domain of ['', location.hostname, '.color-match.io']) document.cookie = name + '=; Max-Age=0; path=/' + (domain ? '; domain=' + domain : '');
  });
  lastView = '';
}
function trackPage(path: string) {
  (window as unknown as Record<string, unknown>)['ga-disable-' + ID] = false;
  if (!document.getElementById('color-match-analytics')) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    window.gtag('config', ID, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
    const script = document.createElement('script'); script.id = 'color-match-analytics'; script.async = true; script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID; document.head.appendChild(script);
  }
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
  window.gtag('set', { page_location: location.origin + path });
  if (lastView !== path) { window.gtag('event', 'page_view', { page_location: location.origin + path, page_title: document.title }); lastView = path; }
}
export default function CookieConsent() {
  const { pathname } = useLocation();
  const [choice, setChoice] = useState(getChoice);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(!getChoice());
    const reopen = () => setVisible(true);
    window.addEventListener('color-match:privacy', reopen);
    return () => window.removeEventListener('color-match:privacy', reopen);
  }, []);
  useEffect(() => { setAnalyticsConsent(choice === 'accepted'); if (choice === 'accepted') trackPage(pathname); else disableAnalytics(); }, [choice, pathname]);
  function choose(value: string) { setAnalyticsConsent(value === 'accepted'); try { localStorage.setItem(KEY, value); localStorage.removeItem('cookieConsent'); } catch { /* Session choice still works without storage. */ } setChoice(value); setVisible(false); }
  if (!visible) return null;
  return <aside aria-label="Analytics preferences" className="fixed bottom-0 inset-x-0 border-t border-surface-border bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-floating z-50"><div className="max-w-6xl mx-auto flex flex-row flex-wrap gap-3 items-center"><p className="text-sm text-ink-secondary basis-full md:basis-auto md:flex-1">Allow optional usage and performance analytics? Change your choice anytime in Privacy settings. <Link to="/privacy" className="underline text-brand-600">Privacy policy</Link></p><button onClick={() => choose('rejected')} className="ui-button-secondary">Reject analytics</button><button onClick={() => choose('accepted')} className="ui-button-secondary">Allow analytics</button></div></aside>;
}
